import { Dimension } from "@/types/mapping";
import { LucideIcon, Search, WandSparkles } from "lucide-react";

interface ActionCardProps {
  icon: LucideIcon;
  iconBgColor: string;
  iconColor: string;
  title: string;
  description: string;
  onClick: () => void;
  disabled?: boolean;
}

export const ActionCard = ({
  icon: Icon,
  iconBgColor,
  iconColor,
  title,
  description,
  onClick,
  disabled,
}: ActionCardProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex items-center gap-3 w-full px-4 py-2 bg-white border border-[#e5e5e5] rounded-[6px] hover:bg-neutral-50 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <div
        className="flex items-center justify-center p-2 rounded-[6px] shrink-0"
        style={{ backgroundColor: iconBgColor }}
      >
        <Icon className="w-3 h-3" style={{ color: iconColor }} />
      </div>
      <div className="flex flex-col items-start gap-1">
        <span className="text-[15px] font-semibold text-[#171717] leading-[1.467] tracking-[0.144px]">
          {title}
        </span>
        <span className="text-[13px] font-medium text-[#737373] leading-[1.385] tracking-[0.252px]">
          {description}
        </span>
      </div>
    </button>
  );
};

export const NoResultActions = ({
  onClickSearchButton,
  onClickExtendButton,
}: {
  dimension: Dimension;
  onClickSearchButton: () => void;
  onClickExtendButton: () => void;
}) => {
  return (
    <div className="flex w-full p-5 flex-col items-start gap-5 border-t border-t-neutral-200">
      <div className="flex flex-col items-start gap-1 w-full">
        <span className="text-[15px] font-semibold text-[#171717] leading-[1.467] tracking-[0.144px]">
          원하는 태그가 없나요?
        </span>
        <span className="text-[13px] font-medium text-[#737373] leading-[1.385] tracking-[0.252px]">
          아래 동작을 통해 원하는 태그를 추가할 수 있습니다.
        </span>
      </div>
      <div className="flex flex-col items-start gap-3 w-full">
        <ActionCard
          icon={Search}
          iconBgColor="#f1f5f9"
          iconColor="#62748e"
          title="검색"
          description="검색으로 태그를 추가합니다."
          onClick={onClickSearchButton}
        />
        <ActionCard
          icon={WandSparkles}
          iconBgColor="#f3e8ff"
          iconColor="#ad46ff"
          title="확장 태그"
          description="태그를 확장하여 새로운 태그를 추가합니다."
          onClick={onClickExtendButton}
        />
      </div>
    </div>
  );
};
